import { getApp, getApps, initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getDatabase } from 'firebase/database'

import { getEnvironment } from '../lib/environment'

export function getFirebaseServices() {
  const firebaseApp = getApps().length
    ? getApp()
    : initializeApp(getEnvironment().firebase)

  return {
    auth: getAuth(firebaseApp),
    database: getDatabase(firebaseApp),
  }
}
